module.exports = "https://cdn.dove.it/_next/static/public/assets/services/videochiamata_340x200.3ab5698445e8ab0c79f2400296f0263f.jpg";